export const clearProgressItems = (payload) => {
    return {
        type: 'CLEAR_PROGRESS_ITEMS',
    }
}



// WEBPACK FOOTER //
// ./src/actions/clearProgressItems.js